import { render, staticRenderFns } from "./action.vue?vue&type=template&id=34733b2c"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"
import style0 from "./action.vue?vue&type=style&index=0&id=34733b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports